
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as aboutTx3jeLhnE3nIeQg3fi2JrHqVer0RwxqsD9TIL7br5HUMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/about.vue?macro=true";
import { default as indexAWZ5gxUGFBaOFEgv63iaAobbyedjLrwbEpkT3vPMptMMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/index.vue?macro=true";
import { default as login5C_45Aa1HR3ezyorBD0L916pPzYAEna1fflaeV9edkeXAMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/login.vue?macro=true";
import { default as logoutDEbHx6_45ZOcRxbhv6jzYushh2LmvOadXoQhfDcvHzABUMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/logout.vue?macro=true";
import { default as signupxUrP5XchurGdnJ5COLM25g8q0Kg0xNn0ddvJD4GRte8Meta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/signup.vue?macro=true";
import { default as partnersaIw9Wl7dyAz12RqVdsK15xb2WdCyLGdvJLK_Kh4rk_4Meta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/partners.vue?macro=true";
import { default as redirectqxxXF8ARqotZz0V_1d76ng8pRa5szb3IeD70xLV3jwIMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/redirect.vue?macro=true";
import { default as settingsooTumdHTXBb_45_K3smNq5wcA4Y211wJ9iVD_45Iuo_45KygcMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/settings.vue?macro=true";
import { default as dashboardgIbCTnl1Shy9Lj3zDYszc0RwDbmNu97iCWpakRxAFXwMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/dashboard.vue?macro=true";
import { default as indexmOTXLSJ9ASM_45PQqa8aTmFfkU393NEZY2StGlqrHzZ0oMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/index.vue?macro=true";
import { default as add_45sequenceCrck6B5H37FrtqoHFob0YOm7jv7lwKLwAxkCsGyS2wUMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/add-sequence.vue?macro=true";
import { default as _91key_93A9EEEKTOh0zxnZ81sJpc0gSJKegltK2QeFydEE0hsZAMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/sequence/[key].vue?macro=true";
import { default as indexqETm3iZDauU_uO_45BAf4rYytgrTPl_O1y5MPJcs4BAWIMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/analytics/index.vue?macro=true";
import { default as purchase_45tokens0cnz3brHOVhLUJ_rWAkdlJxzPeUirDR_WpePH_451QSSAMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/purchase-tokens.vue?macro=true";
import { default as sales_45leads5I4UpfNaGprT5_45HuAeI7RM1_45ftwMapgtXRRmmLNPQDYMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/sales-leads.vue?macro=true";
import { default as index9VXMkCfoxWAQRKYEsie_EKtO3FStY0W7IpIwE9hZoMAMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/verify-email/index.vue?macro=true";
import { default as _91code_93h_45whSyH_Jc2IaQ1LGC_45Xv2yhb1syHq4zZDeRSVguLwsMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/verify-email/[code].vue?macro=true";
import { default as forum_45marketingHrK_wr6FLCUIcA8geTUTNi3ZzshvnhVpX5CEyKypLuAMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/forum-marketing.vue?macro=true";
import { default as payment_45confirmationZqIGmLFjS4X8_45_45YgFbOtrqc0oxlW2KZ0nF0Out4FC4YMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/payment-confirmation.vue?macro=true";
import { default as twitter_45tips_4520255_egkjflvbkWqj_MJBnQM7iby47HasEfbFfmSSPwH3UMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/twitter-tips-2025.vue?macro=true";
import { default as valid_45verification_45codelylSl86R3p4apjMUalGoh_EbEj6Sv8PhcXTsaLCh72oMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/valid-verification-code.vue?macro=true";
import { default as invalid_45verification_45codegNl8Oy943LlOuDwZqkabbwdgAixqQSzn1bjv7O8pu48Meta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/invalid-verification-code.vue?macro=true";
import { default as indexp2g_rCQTWWSIHmv_9vIbGwAgE7GMIZDgKRJ2AtoyW_45QMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/analytics/[productID]/index.vue?macro=true";
import { default as social_45media_45marketingQHb0q4E1FqAFgpGQG9sTy9rD4i_GI42bjO_451r_gU4oEMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/social-media-marketing.vue?macro=true";
import { default as the_45ultimate_45guide_45to_45lead_45generation_45in_452024Tk5_45YDNjBY_TYxrJve5k0gyJSYiZkPOxa1hc_F6os88Meta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/the-ultimate-guide-to-lead-generation-in-2024.vue?macro=true";
import { default as _10_45tips_45to_45build_45a_45strong_45digital_45presence_45in_452025qybaFi1NP1sCAQOOzJht__45nV8Y1IroNwrXLapa2lhGkMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/10-tips-to-build-a-strong-digital-presence-in-2025.vue?macro=true";
import { default as how_45social_45media_45is_45reshaping_45the_45retail_45landscapeDui0W3RdW4cLNYtCO71SxO2k_5ohGBmPVR3amJZpJd8Meta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/how-social-media-is-reshaping-the-retail-landscape.vue?macro=true";
import { default as how_45to_45respond_45to_45online_45reviews_45the_4510_45golden_45rulesrElcMGEfo8J4EAygFcJccqXP8llBsMJYbeLxoUD7y7YMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/how-to-respond-to-online-reviews-the-10-golden-rules.vue?macro=true";
import { default as how_45to_45qualify_45leads_45effectively_45a_45step_45by_45step_45approachYxmQzY3gAt1E_QvzIjEtO_ii31s30CvJXTR9f3Fl6MkMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/how-to-qualify-leads-effectively-a-step-by-step-approach.vue?macro=true";
import { default as how_45to_45develop_45a_45content_45marketing_45strategy_45a_45beginners_45guideAinsBU2Y6hozVFryByV_UeKy4xzu_Ue5bBS20rXlZ_454Meta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/how-to-develop-a-content-marketing-strategy-a-beginners-guide.vue?macro=true";
import { default as _11_45closing_45phrases_45that_45consistently_45seal_45the_45deal_45use_45these_45todaynUGQKORCeJCZ6p96qcY6aKOlSNVaJckaFq_g5vMClrgMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/11-closing-phrases-that-consistently-seal-the-deal-use-these-today.vue?macro=true";
import { default as how_45to_45improve_45saas_45customer_45retention_45with_45data_45driven_45strategiesT2tFGvhv9OG9jJZOKtR8yGRrhP0_NUHd9Py9IYr9FEIMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/how-to-improve-saas-customer-retention-with-data-driven-strategies.vue?macro=true";
import { default as understanding_45psychographics_45in_45marketing_45a_45comprehensive_45explorationUUVo1VLK4mn__NeM0royzDYtt07GLE_kLKFvHWxHYKoMeta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/understanding-psychographics-in-marketing-a-comprehensive-exploration.vue?macro=true";
import { default as _25_45effective_45ways_45to_45drive_45traffic_45to_45your_45website_45free_45and_45paid_45methodsqL9FVsWB3ac79EfU7Q7PZ7AbHgCk9pb5_45AaUOMDLWL8Meta } from "/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/25-effective-ways-to-drive-traffic-to-your-website-free-and-paid-methods.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/logout.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/signup.vue")
  },
  {
    name: "partners",
    path: "/partners",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/partners.vue")
  },
  {
    name: "redirect",
    path: "/redirect",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/redirect.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/settings.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/dashboard.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/index.vue")
  },
  {
    name: "add-sequence",
    path: "/add-sequence",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/add-sequence.vue")
  },
  {
    name: "sequence-key",
    path: "/sequence/:key()",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/sequence/[key].vue")
  },
  {
    name: "analytics",
    path: "/analytics",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/analytics/index.vue")
  },
  {
    name: "purchase-tokens",
    path: "/purchase-tokens",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/purchase-tokens.vue")
  },
  {
    name: "blog-sales-leads",
    path: "/blog/sales-leads",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/sales-leads.vue")
  },
  {
    name: "verify-email",
    path: "/verify-email",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/verify-email/index.vue")
  },
  {
    name: "verify-email-code",
    path: "/verify-email/:code()",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/verify-email/[code].vue")
  },
  {
    name: "blog-forum-marketing",
    path: "/blog/forum-marketing",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/forum-marketing.vue")
  },
  {
    name: "payment-confirmation",
    path: "/payment-confirmation",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/payment-confirmation.vue")
  },
  {
    name: "blog-twitter-tips-2025",
    path: "/blog/twitter-tips-2025",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/twitter-tips-2025.vue")
  },
  {
    name: "valid-verification-code",
    path: "/valid-verification-code",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/valid-verification-code.vue")
  },
  {
    name: "invalid-verification-code",
    path: "/invalid-verification-code",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/invalid-verification-code.vue")
  },
  {
    name: "analytics-productID",
    path: "/analytics/:productID()",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/analytics/[productID]/index.vue")
  },
  {
    name: "blog-social-media-marketing",
    path: "/blog/social-media-marketing",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/social-media-marketing.vue")
  },
  {
    name: "blog-the-ultimate-guide-to-lead-generation-in-2024",
    path: "/blog/the-ultimate-guide-to-lead-generation-in-2024",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/the-ultimate-guide-to-lead-generation-in-2024.vue")
  },
  {
    name: "blog-10-tips-to-build-a-strong-digital-presence-in-2025",
    path: "/blog/10-tips-to-build-a-strong-digital-presence-in-2025",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/10-tips-to-build-a-strong-digital-presence-in-2025.vue")
  },
  {
    name: "blog-how-social-media-is-reshaping-the-retail-landscape",
    path: "/blog/how-social-media-is-reshaping-the-retail-landscape",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/how-social-media-is-reshaping-the-retail-landscape.vue")
  },
  {
    name: "blog-how-to-respond-to-online-reviews-the-10-golden-rules",
    path: "/blog/how-to-respond-to-online-reviews-the-10-golden-rules",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/how-to-respond-to-online-reviews-the-10-golden-rules.vue")
  },
  {
    name: "blog-how-to-qualify-leads-effectively-a-step-by-step-approach",
    path: "/blog/how-to-qualify-leads-effectively-a-step-by-step-approach",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/how-to-qualify-leads-effectively-a-step-by-step-approach.vue")
  },
  {
    name: "blog-how-to-develop-a-content-marketing-strategy-a-beginners-guide",
    path: "/blog/how-to-develop-a-content-marketing-strategy-a-beginners-guide",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/how-to-develop-a-content-marketing-strategy-a-beginners-guide.vue")
  },
  {
    name: "blog-11-closing-phrases-that-consistently-seal-the-deal-use-these-today",
    path: "/blog/11-closing-phrases-that-consistently-seal-the-deal-use-these-today",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/11-closing-phrases-that-consistently-seal-the-deal-use-these-today.vue")
  },
  {
    name: "blog-how-to-improve-saas-customer-retention-with-data-driven-strategies",
    path: "/blog/how-to-improve-saas-customer-retention-with-data-driven-strategies",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/how-to-improve-saas-customer-retention-with-data-driven-strategies.vue")
  },
  {
    name: "blog-understanding-psychographics-in-marketing-a-comprehensive-exploration",
    path: "/blog/understanding-psychographics-in-marketing-a-comprehensive-exploration",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/understanding-psychographics-in-marketing-a-comprehensive-exploration.vue")
  },
  {
    name: "blog-25-effective-ways-to-drive-traffic-to-your-website-free-and-paid-methods",
    path: "/blog/25-effective-ways-to-drive-traffic-to-your-website-free-and-paid-methods",
    component: () => import("/home/NodeJs/Nuxt3/ForumLeadsFinder-Nuxt3/pages/blog/25-effective-ways-to-drive-traffic-to-your-website-free-and-paid-methods.vue")
  }
]